import { render } from "./ScreenQuestionOptionsGreen.vue?vue&type=template&id=17295242&scoped=true&ts=true"
import script from "./ScreenQuestionOptionsGreen.vue?vue&type=script&lang=ts"
export * from "./ScreenQuestionOptionsGreen.vue?vue&type=script&lang=ts"

import "./ScreenQuestionOptionsGreen.vue?vue&type=style&index=0&id=17295242&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17295242"]])

export default __exports__